import { ConsultantRating } from "../../../models/Consultant";
import Organisation from "../../../models/Organisation";
import { getCompetencesLabels } from "../../../utils/competence.utils";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT_TYPES } from "../../../configs/constants/DateTimeFormatTypes";
import AppIcon from "../../Core/AppIcon/AppIcon";

interface Props {
	data: ConsultantRating;
	onRowClick: () => void;
	deleteRate: (consultantId: string, ratingId: string) => void;
	organization?: Organisation;
}

const ConsultantFeedback = ({ data, onRowClick, organization, deleteRate }: Props) => {
	const { id, comment, customer, consultant, metadata, performance, punctualityScore, job } = data;
	const getRateColor = (rate: number) => {
		return rate < 3 ? "hsl(var(--danger))" : "#000000";
	};
	return (
		<tr key={id}>
			<td onClick={() => onRowClick()}>{`${consultant.firstName} ${consultant.lastName}`}</td>
			<td onClick={() => onRowClick()}>
				<span>{`#${job.orderNumber}`}</span>
				<br />
				<span>{` ${customer.name}`}</span>
			</td>
			<td onClick={() => onRowClick()}>
				{getCompetencesLabels(organization?.competences ?? [], job.competence, undefined).service}
			</td>

			<td onClick={() => onRowClick()}>
				<span>
					{metadata.createdAt
						? metadata.createdBy.firstName + " " + metadata.createdBy.lastName
						: ""}
				</span>
				<br />
				<span>
					{metadata.createdAt ? dayjs(metadata.createdAt).format(DATE_TIME_FORMAT_TYPES.DATE) : ""}
				</span>
			</td>
			<td
				style={{ color: getRateColor((performance + punctualityScore) / 2) }}
				onClick={() => onRowClick()}
			>
				{(performance + punctualityScore) / 2}
			</td>
			<td onClick={() => onRowClick()}>{!!comment ? comment : "-"}</td>
			<td>
				<AppIcon
					icon="delete-red"
					size="12px"
					onClick={() => {
						deleteRate(consultant.id, id);
					}}
				/>
			</td>
		</tr>
	);
};

export default ConsultantFeedback;
